// extracted by mini-css-extract-plugin
module.exports = {"cardItemContainer":"styles_cardItemContainer__3OgKc","imageContainer":"styles_imageContainer__3b150","descriptionContainer":"styles_descriptionContainer__Sqcnj"};